import RichText from '../RichText';
import SingleLineText from '../SingleLineText';

const mock = {
	title: SingleLineText.Mock,
	description: RichText.Mock,
};

export default mock;
